<template>
    <div class="HomeLinks">
        <ul class="list-group mb-0 visit-list">
            <li class="list-group-item rounded-0">
                <a href="http://www.fifmi.org" target="_blank" class="d-flex align-items-center">
                    <div class="visit-icon mr-3">
                        <img src="../../assets/images/world.png" alt="" class="img-fluid" />
                    </div>
                    <div class="visit-title">Visit our Website</div>
                </a>
            </li>
            <li class="list-group-item rounded-0">
                <a href="https://ezekieltvchannel.com" target="_blank" class="d-flex align-items-center">
                    <div class="visit-icon mr-3">
                        <img src="../../assets/images/tv.png" alt="" class="img-fluid" />
                    </div>
                    <div class="visit-title">Ezekiel Tv</div>
                </a>
            </li>
            <li class="list-group-item rounded-0">
                <a href="/events" class="d-flex align-items-center">
                    <div class="visit-icon mr-3">
                        <img src="../../assets/images/user.png" alt="" class="img-fluid" />
                    </div>
                    <div class="visit-title">Conferences</div>
                </a>
            </li>
            <li class="list-group-item rounded-0">
                <a href="/online-giving" class="d-flex align-items-center">
                    <div class="visit-icon mr-3">
                        <img src="../../assets/images/donation.png" alt="" class="img-fluid" />
                    </div>
                    <div class="visit-title">Online Giving</div>
                </a>
            </li>
            <li class="list-group-item rounded-0">
                <a href="/bible-school" class="d-flex align-items-center">
                    <div class="visit-icon mr-3">
                        <img src="../../assets/images/donation.png" alt="" class="img-fluid" />
                    </div>
                    <div class="visit-title">Amfcc Bible School</div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
